import * as React from 'react';
import { FC } from 'react';
import { CasinoFiltersProps, ProviderInfo } from './types';

const Provider: FC<{
  active: boolean;
  providerInfo: ProviderInfo;
  onClick: (v: string) => void;
  locales: CasinoFiltersProps['locales'];
}> = ({ active, providerInfo, onClick, locales }) => (
  <a className={`item bwWrapper ${active ? 'active' : 'inactive'}`} onClick={() => onClick(providerInfo.provider)}>
    <img
      alt={locales[providerInfo.name]}
      srcSet={providerInfo.srcset}
      src={providerInfo.srcset.split(',')[0]}
      width="90"
      height="40"
    />
  </a>
);

export default Provider;
